var _mask, _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgShadowDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 1009,
    viewBox: "0 0 252 1009",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_84_4315",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 252,
    height: 1020
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_84_4315",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H252V1020H0V0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H252V1020H0V0Z",
    fill: "#273142"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M251 0V1020H253V0H251ZM1 1020V0H-1V1020H1Z",
    fill: "#313D4F",
    mask: "url(#path-1-inside-1_84_4315)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_84_4315)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_84_4315)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -58.1538,
    y: -77.8395,
    width: 83.3538,
    height: 1135.24,
    fill: "#1D2636"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_84_4315",
    x: -98.1538,
    y: -117.839,
    width: 163.354,
    height: 1215.24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect1_foregroundBlur_84_4315"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgShadowDark);
export default __webpack_public_path__ + "static/media/bg-shadow-dark.fd5f16b16ba1ab81c7560848a5a07197.svg";
export { ForwardRef as ReactComponent };